import { ArrowIcon, HouseIcon } from '@src/components/common/icons';
import React from 'react';
import styled from 'styled-components';

interface BreadcrumbItemData {
  label: string;
  onClick?: () => void;
}

interface BreadcrumbsProps {
  items: BreadcrumbItemData[];
}

interface BreadcrumbItemProps {
  label: string;
  onClick?: () => void;
}

export const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({
  label,
  onClick,
}) => {
  return onClick ? (
    <ClickableText onClick={onClick}>{label}</ClickableText>
  ) : (
    <NonClickableText>{label}</NonClickableText>
  );
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  if (items.length === 0) return null;

  const [firstItem, ...restItems] = items;

  return (
    <BreadcrumbsWrapper>
      <HomeContainer onClick={firstItem.onClick}>
        <HouseIcon />
        <BreadcrumbItem label={firstItem.label} onClick={firstItem.onClick} />
      </HomeContainer>
      {restItems.map(item => (
        <React.Fragment key={item.label}>
          <ArrowIcon />
          <BreadcrumbItem label={item.label} onClick={item.onClick} />
        </React.Fragment>
      ))}
    </BreadcrumbsWrapper>
  );
};

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 8px;

  svg {
    path {
      transition: stroke var(--transition-normal) ease;
    }
  }

  &:hover {
    span {
      color: var(--accent);
    }

    svg {
      path {
        stroke: var(--accent);
      }
    }
  }
`;

const ClickableText = styled.span`
  cursor: pointer;
  transition: color var(--transition-normal) ease;

  &:hover {
    color: var(--accent);
  }
`;

const NonClickableText = styled.span`
  color: var(--text-secondary);
`;

export const BreadcrumbsWrapper = styled.div`
  display: flex;
  height: 24px;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  background: transparent;
  color: var(--text-muted);
  border: none;
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  transition: color var(--transition-normal) ease;
`;
